import { defaultSignalFilters, type SignalFilters, type SignalKind } from './types';

export interface SignalWorkspaceState {
  watchedIds: string[];
  hiddenIds: string[];
  lastSeenAt: string | null;
}

const emptyWorkspace: SignalWorkspaceState = { watchedIds: [], hiddenIds: [], lastSeenAt: null };

function key(kind: SignalKind, suffix: string): string {
  return `business-calculator-kr:signal:${kind.toLowerCase()}:${suffix}:v1`;
}

export function loadSignalFilters(kind: SignalKind): SignalFilters {
  if (typeof window === 'undefined') return defaultSignalFilters;
  try {
    const raw = window.localStorage.getItem(key(kind, 'filters'));
    if (!raw) return defaultSignalFilters;
    const parsed = JSON.parse(raw) as Partial<SignalFilters>;
    return {
      keyword: typeof parsed.keyword === 'string' ? parsed.keyword : '',
      region: typeof parsed.region === 'string' ? parsed.region : '',
      category: typeof parsed.category === 'string' ? parsed.category : 'ALL',
      closingWithinDays: typeof parsed.closingWithinDays === 'number' && parsed.closingWithinDays >= 0
        ? parsed.closingWithinDays
        : null,
    };
  } catch {
    return defaultSignalFilters;
  }
}

export function saveSignalFilters(kind: SignalKind, filters: SignalFilters): void {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(key(kind, 'filters'), JSON.stringify(filters));
}

export function loadSignalWorkspace(kind: SignalKind): SignalWorkspaceState {
  if (typeof window === 'undefined') return emptyWorkspace;
  try {
    const raw = window.localStorage.getItem(key(kind, 'workspace'));
    if (!raw) return emptyWorkspace;
    const parsed = JSON.parse(raw) as Partial<SignalWorkspaceState>;
    return {
      watchedIds: Array.isArray(parsed.watchedIds) ? parsed.watchedIds.filter((value): value is string => typeof value === 'string') : [],
      hiddenIds: Array.isArray(parsed.hiddenIds) ? parsed.hiddenIds.filter((value): value is string => typeof value === 'string') : [],
      lastSeenAt: typeof parsed.lastSeenAt === 'string' ? parsed.lastSeenAt : null,
    };
  } catch {
    return emptyWorkspace;
  }
}

export function saveSignalWorkspace(kind: SignalKind, workspace: SignalWorkspaceState): void {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(key(kind, 'workspace'), JSON.stringify(workspace));
}
